var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForkliftHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29433",
    "data-name": "Group 29433",
    transform: "translate(-488.999 -502.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(488.999 502.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29432",
    "data-name": "Group 29432",
    transform: "translate(160.996 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29431",
    "data-name": "Group 29431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50876",
    "data-name": "Path 50876",
    d: "M62.95,121.674h4.869l3.984,8.669H62.95Z",
    transform: "translate(282.292 392.66)",
    fill: "#ada0ad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50877",
    "data-name": "Path 50877",
    d: "M44.765,216.236h9.647l2.158,7.009h-11.8Z",
    transform: "translate(299.555 302.894)",
    fill: "#ffbf31",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50878",
    "data-name": "Path 50878",
    d: "M250.439,109.633a.342.342,0,1,1,.651-.209l3.837,11.858H261.2a.343.343,0,0,1,0,.686h-6.526a.342.342,0,0,1-.326-.237Z",
    transform: "translate(104.328 404.515)",
    fill: "#d1991f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_542",
    "data-name": "Ellipse 542",
    cx: 1.66,
    cy: 1.66,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(343.171 527.435) rotate(-73.14)",
    fill: "#847784"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_543",
    "data-name": "Ellipse 543",
    cx: 1.66,
    cy: 1.66,
    rx: 1.66,
    ry: 1.66,
    transform: "translate(354.096 524.664)",
    fill: "#847784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50879",
    "data-name": "Path 50879",
    d: "M347.2,223.61H351.7a.442.442,0,0,1,.441.441v4.184a.442.442,0,0,1-.441.441H347.2a.442.442,0,0,1-.441-.441v-4.184A.442.442,0,0,1,347.2,223.61Z",
    transform: "translate(12.881 295.894)",
    fill: "#f0b16e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50880",
    "data-name": "Path 50880",
    d: "M347.2,123.709H351.7a.442.442,0,0,1,.441.441v4.184a.442.442,0,0,1-.441.441H347.2a.442.442,0,0,1-.441-.441V124.15A.442.442,0,0,1,347.2,123.709Z",
    transform: "translate(12.881 390.729)",
    fill: "#fcd4a9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29416",
    "data-name": "Group 29416",
    transform: "translate(361.415 514.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50418",
    "data-name": "Path 50418",
    d: "M381.849,123.709h1.829v2.184h-1.829Zm0,5.066h1.829v2.184h-1.829Z",
    transform: "translate(-381.849 -123.709)",
    fill: "#e33f65",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkliftHighlighted);
export default __webpack_public_path__ + "static/media/forkliftHighlighted.8f863dac5037b16f8f1a33e70b2e2486.svg";
export { ForwardRef as ReactComponent };